import { render, staticRenderFns } from "./footerName.vue?vue&type=template&id=9926da00&scoped=true"
import script from "./footerName.vue?vue&type=script&lang=js"
export * from "./footerName.vue?vue&type=script&lang=js"
import style0 from "./footerName.vue?vue&type=style&index=0&id=9926da00&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9926da00",
  null
  
)

export default component.exports